export const getUrlParams = (param) => {
    const url = window.location.search.substring(1);
    const paramsList = url.split('&');
    let paramName;

    for (let i = 0; i < paramsList.length; i++) {
        paramName = paramsList[i].split('=');

        if (paramName[0] === param) {
            return typeof paramName[1] === undefined ? true : decodeURIComponent(paramName[1]);
        }
    }
    return false;
};

export const getDomainName = () => {
    return document.domain.split('.').slice(-2).join('.');
}